import { Facility } from "encamp-prisma/generated/browser";

type PartialNullable<T> = { [P in keyof T]?: T[P] | undefined | null };

export function getOakNotReportingReason(facility?: PartialNullable<Facility>) {
  if (!facility) return null;

  if (facility.isClosed) {
    return "Closed";
  }

  if (facility.colocationReportingFacilityId) {
    return "Co-located";
  }

  if (facility.isNotReporting) {
    return "Under Thresholds";
  }

  if (facility.isInactive) {
    return "Is Inactive";
  }

  if (facility.isNotReportingThroughEncamp) {
    return "Without Encamp";
  }

  return null;
}
